import { LoginView, LoginProps } from 'pages/login/loginView/LoginView'

export const LoginPage = ({ login }: LoginProps) => {
  return <LoginView login={login} />
}
